import WrapperService from "@/modules/core/services/wrapper-service";
import { createPageableParams } from "@/modules/core/services/table-utils";

const sortFacilityProcessJobFields = ["processName", "badge", "assignedToName", "assignedToRoleName", "checkbox"];
const sortFacilityProcessJobDatabaseFields = ["process", "accepted", "assignedTo", "p.role", "lastResult"];

const API_URL = process.env.VUE_APP_ROOT_API + "/api/v1/process/job"
const serviceName = "ProcessJob-Service: ";

export default class ProcessJobService {
  static async readPageableFacilityProcessJobFromAPI(facilityId, page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, sortFacilityProcessJobFields, sortFacilityProcessJobDatabaseFields);
    await WrapperService.get(API_URL + "/facility/" + facilityId, { params: params }, serviceName, successF, errorF);
  }

  static async readFromAPI(id, successF, errorF) {
    await WrapperService.get(API_URL + '/' + id, null, serviceName, successF, errorF);
  }

  static postToAPI(processJob, successF, errorF) {
    WrapperService.post(API_URL, processJob, serviceName, successF, errorF);
  }

  static putToAPI(processJob, successF, errorF) {
    WrapperService.put(API_URL + "/" + processJob.id, processJob, serviceName, successF, errorF);
  }

  static deleteFromAPI(processJob, softDelete, successF, errorF) {
    if (softDelete) {
      WrapperService.delete(API_URL + "/" + processJob.id, serviceName, successF, errorF);
      return;  // bugfix manfred
    }
    WrapperService.delete(API_URL + "/" + processJob.id + "/true", serviceName, successF, errorF);
  }

  static deleteItemsFromAPI(processJobIdArray, softDelete, successF, errorF) {
    if (softDelete) {
      WrapperService.put(API_URL + "/multidelete/false", processJobIdArray, serviceName, successF, errorF);
      return;
    }
    WrapperService.put(API_URL + "/multidelete/true", processJobIdArray, serviceName, successF, errorF);
  }


  static restoreFromAPI(processJob, successF, errorF) {
    WrapperService.put(API_URL + "/restore/" + processJob.id, null, serviceName, successF, errorF);
  }

  static async readAccessibleForHandlingJob(id, successF, errorF) {
    await WrapperService.get(API_URL + '/' + id + '/read-open', null, serviceName, successF, errorF);
  }

  static startProcessJob(id, gpsChecked, successF, errorF) {
    WrapperService.put(API_URL + "/" + id + "/start/" + gpsChecked, null, serviceName, successF, errorF);
  }

  static updateProcessJob(id, processResult, successF, errorF) {
    WrapperService.put(API_URL + "/" + id + "/update", processResult, serviceName, successF, errorF);
  }

  static updateAndGenerateReport(processJobId, processResult, successF, errorF) {
    WrapperService.put(API_URL + "/generateReport/" + processJobId, processResult, serviceName, successF, errorF);
  }

  static generateReportByProcessJobResultId(id, successF, errorF) {
    WrapperService.get(API_URL + "/"+ id + "/generateReportByProcessJobResult", null, serviceName, successF, errorF);
  }

  static closeProcessJob(id, rideCount, fileNumber, successF, errorF) {
    let formData = new FormData();

    if (rideCount) {
      formData.append("rideCount", rideCount)
    }

    if (fileNumber) {
      formData.append("fileNumber", fileNumber);
    }

    WrapperService.putWithErrorCause(API_URL + "/" + id + "/close", formData, serviceName, successF, errorF);
  }

  static acceptProcessJob(id, successF, errorF) {
    WrapperService.put(API_URL + "/" + id + "/accept", null, serviceName, successF, errorF);
  }

  static rejectProcessJob(id, successF, errorF) {
    WrapperService.put(API_URL + "/" + id + "/reject", null, serviceName, successF, errorF);
  }
}
